import commonApi from "@/api/common/commonApi";
import { ACCESS } from "@/api/common/commonLimit";
import { List } from "@/components/popoverSelect/limit";
import { acLoginSwitch, SOCIETY_POWER } from "@/config/config";
import { getNavsInit } from "@/config/navs";
import { POWER_APPROVE, POWER_BUDGET, POWER_COMPANY, POWER_FINANCIAL, POWER_FINANCIAL_LIST, POWER_FISCAL_ANALYSIS, POWER_PURCHASE } from "@/config/power";
import instance from "@/requestConfig/intercept";
import router from "@/router";
import { CurrentPower } from "@/store/interface/common";
import { nextTick, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import usePower, { getTree } from "./power/usePower";

export default () => {
  const store = useStore();
  const route = useRoute();
  const { judgePowerGroup } = usePower();

  const initData = async () => {
    // await getAgentUserId();
  };

  const getCompanyCounter = async () => {
    const { data } = await commonApi.getCompanyCounter();
    await store.dispatch("setTagBadges", data);
    await store.dispatch("setBadges", data);
  };

  const getAgentUserId = async () => {
    const {
      name,
      params: { id },
    } = useRoute();
    const userId = store.getters.getUserinfo("userid");
    const { data } = await commonApi.getAgentUserId(userId);
    await store.dispatch("setTagList", { data, name, id });
  };

  const getCurrentTokenByEnterprise = async (id?: string, companyId?: string, accessSystem = ACCESS.ZERO) => {
    const phone = store.getters.getUserinfo("phone");
    const params = {
      phone,
      companyId: String(companyId),
      accessSystem,
      ...acLoginSwitch,
      username: phone,
    };

    const data = await commonApi.LoginNonTrace(params);
    if (!data) return;
    const { access_token } = data;
    return access_token;
  };
  const getCurrentToken = async (id?: string, accessSystem = ACCESS.ZERO) => {
    const code = id || store.getters.getTagCurrent?.code;
    const arr = store.getters.getTagList;
    const o = code ? arr.find((item: List) => item.code == code) : arr[0];
    const phone = store.getters.getUserinfo("phone");
    console.log(o, "ooo", code, id);
    console.log(id, accessSystem, "getCurrentToken");
    const params = {
      phone,
      companyId: o.name,
      accessSystem,
      ...acLoginSwitch,
      username: phone,
    };

    const data = await commonApi.LoginNonTrace(params).catch(async (res: any) => {
      store.commit("SET_TAG_TOKEN", {});
      await store.dispatch("setNavs", getNavsInit());
    });
    if (!data) return false;
    const { access_token } = data;
    // data.data.userinfo.isPurchase = false;
    instance.defaults.headers["Authorization"] = "Bearer " + access_token; // 设置请求头
    // data.data.userinfo.industryid = 0;
    store.commit("SET_TAG_TOKEN", data);
    if (accessSystem == ACCESS.ZERO) {
      const power = await getTree();
      console.log(data, power);
      await store.dispatch("setPower", power);
      nextTick(async () => {
        const { isApprove = false, isBudget = false, isPurchase = false } = data.data.userinfo;
        const powers: CurrentPower = {
          isApprove: true,
          isBudget: isBudget && judgePowerGroup(POWER_BUDGET),
          isPurchase: isPurchase && judgePowerGroup(POWER_PURCHASE),
          isFinancial: judgePowerGroup(POWER_FINANCIAL),
          isFinancialList: judgePowerGroup(POWER_FINANCIAL_LIST),
          isFiscalAnalysis: judgePowerGroup(POWER_FISCAL_ANALYSIS),
          isCompany: judgePowerGroup(POWER_COMPANY),
        };
        console.log(powers);
        await store.dispatch("setCurrentPower", powers);
      });
    }
    isPower(store.getters.getCurrentPower);
    return true;
  };

  // 判断模块权限 如果没有后退
  const isPower = (userinfo: CurrentPower, name?: string) => {
    if (!userinfo) return;
    if (!name) name = route.name as string;
    console.log(name, userinfo);
    const arr = Object.values(SOCIETY_POWER).find((arr) => arr[0] == name);
    if (arr) {
      if (!userinfo[arr[1]]) {
        router.push("/");
        setTimeout(location.reload);
      }
    }
  };
  return { initData, getCurrentToken, isPower, getCompanyCounter, getCurrentTokenByEnterprise };
};
